<template>
    <router-link v-if="link" :to="{name: link, params: params}" :class="[size, linkstate]" class="ubutton"><span>{{text}}</span></router-link>
    <button v-else-if="type === 'button' && !icon" :class="[btnsize, state, {round: round}, align, {disabled: isDisabled}]" class="ubutton" :disabled="isDisabled" @click.stop.prevent="click">
      <slot></slot>
      <span v-html="text"></span>
      <slot name="last"></slot>
    </button>
    <span v-else-if="type === 'text'" :class="[textstate, align, isDisabled ? 'cursornone' : 'cursorButton']" class="ubutton" @click.stop.prevent="click" v-html="text"></span>
    <div v-else :class="[boxsize, iconstate, {round: round}, align, {cursorButton: !isDisabled}]" class="ubutton" @click.stop.prevent="click">
      <span v-if="lineSize" :class="linesize" :style="lineStyle">
        <icon :size="iconSize" :uicon="icon" :style="iconStyle" :state="iconState"/>
      </span>
      <icon v-else :size="iconSize" :uicon="icon" :style="iconStyle" :state="iconState"/>
      <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    type: {type: String, default: 'button'},
    size: { type: String, default: 'small' },
    text: { type: String },
    state: { type: String, default: 'deactive' },
    link: { type: String },
    params: { type: Object },
    icon: { type: String },
    iconSize: { type: String },
    iconState: {type: String},
    iconStyle: { type: Object },
    lineSize: { type: String },
    lineStyle: { type: Object },
    round: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    align: { type: String }
  },
  name: 'Ubutton',
  computed: {
    linkstate () {
      return 'link-' + this.state
    },
    boxsize () {
      return 'box-' + this.size
    },
    iconstate () {
      return 'icon-' + this.state
    },
    btnsize () {
      return 'btn-' + this.size
    },
    linesize () {
      return 'line-' + this.lineSize
    },
    roundclass () {
      return 'round-' + this.size
    },
    textstate () {
      // return (this.disabled) ? 'disable' : this.state
      return this.state
    },
    isDisabled () {
      if (this.disabled) {
        return 'disabled'
      } else {
        console.log(this.disabled)
        if (this.state === 'disable') {
          return 'disabled'
        } else {
          return false
        }
      }
    }
  },
  methods: {
    click (e) {
      // console.log('click', this.disabled, e)
      if (this.isDisabled !== 'disabled') {
        // console.log('click', this.disabled, e)
        this.$emit('click', e)
      }
    }
  }
}
</script>

<style scoped>
.btn-medium {
  min-width: 120px;
  min-height: 40px;
  padding: 12px 20px 12px 20px;
}
.btn-small {
  min-width: 90px;
  min-height: 30px;
  padding: 5px 15px 5px 15px;
}
.btn-xsmall {
  min-width: 60px;
  min-height: 25px;
}
.btn-xxsmall {
  min-width: 40px;
  min-height: 25px;
  padding: 3px 6px 3px 6px;
}
.btn-xsmall button:focus,
.btn-small button:focus,
.btn-medium button:focus {
  outline: 0;
}
.box-medium {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
}
.box-small {
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
}
.box-xsmall {
  display: flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
}
.box-button {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  min-width: 100px;
}
.icon-toogle {
  color: var(--icon-deactive);
}
.icon-toogle:hover {
  color: var(--icon-base);
}
.icon-deactive {
  color: var(--icon-base);
}
.icon-deactive:hover {
  color: var(--icon-over);
}
.icon-active {
  color: var(--icon-active);
}
.icon-disable {
  color: var(--icon-disable);
}
.icon-require {
  color: var(--icon-require);
}
.icon-highlight {
  color: var(--bg-white);
}
.icon-highlight:hover {
  color: var(--text-guide);
}
.icon-in-deactive {
  color: var(--bg-white);
  background-color: var(--text-title);
}
.icon-in-deactive:hover {
  color: var(--text-guide);
}
.icon-workvisible {
  color: var(--text-base);
}
.icon-workvisible:hover {
  color: var(--icon-over);
}
.line-small {
  display: flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--line-base);
}
.line-small span {
  min-width: 14px;
  width: 14px;
  height: 14px;
  font-size: 14px;
}
.round .line-small {
  border-radius: 25px;
}
.box-medium.round {
  border-radius: 20px;
}
.box-small.round, .btn-small.round {
  border-radius: 15px;
}
.box-xsmall.round {
  border-radius: 12px;
}
.link-deactive {
  color: var(--icon-base);
}
.link-deactive:hover {
  color: var(--icon-over);
}
.cursornone {
  cursor: context-menu;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Ubutton.vue